import {Map} from 'immutable'

let sendInterval = document.querySelector('body').dataset.contactFormSendInterval;
let config = Map({
  sendInterval
})

export default config;



// WEBPACK FOOTER //
// ./src/config.js